// **  Initial State
const initialState = {
  userData: {},
  currentFacility: null,
  facilities: []
}

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'LOGIN':
      console.log('LOGIN!!!!')
      return {
        ...state,
        userData: action.data,
        currentFacility: action.currentFacility,
        facilities: action.facilities,
        [action.config.storageTokenKeyName]: action[action.config.storageTokenKeyName],
        [action.config.storageRefreshTokenKeyName]: action[action.config.storageRefreshTokenKeyName]
      }
    case 'LOGOUT':
      const obj = { ...action }
      delete obj.type
      return { ...state, userData: {}, ...obj }
    default:
      return state
  }
}

export default authReducer
